export default {
    SET_PACKAGE: "SET_PACKAGE",
    GET_PACKAGE_DATA: "GET_PACKAGE_DATA",
    GET_INSTOCK_PACKAGE_DATA: "GET_INSTOCK_PACKAGE_DATA",
    GET_PACKAGE_DETAIL: "GET_PACKAGE_DETAIL",
    UPDATE_PACKAGE_DETAIL: "UPDATE_PACKAGE_DETAIL",
    GET_LOTS_LIST: "GET_LOTS_LIST",
    CHANGE_PAGE_NUMBER: 'package/CHANGE_PAGE_NUMBER',
    CHANGE_PAGE_SIZE: 'package/CHANGE_PAGE_SIZE'
}